import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { PaymentProofsPage } from './pages/PaymentProofsPage';
import { UserReviewsPage } from './pages/UserReviewsPage';
import { WorkVideosPage } from './pages/WorkVideosPage';
import { SalaryListPage } from './pages/SalaryListPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/payment-proofs" element={<PaymentProofsPage />} />
        <Route path="/user-reviews" element={<UserReviewsPage />} />
        <Route path="/work-videos" element={<WorkVideosPage />} />
        <Route path="/salary-list" element={<SalaryListPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
